import React, {useState} from "react";
import SearchTable from "../../../primer/Search-Table";
import {getObjectFromArrayOfObjects} from "../../../../_helpers/helperFunctions";
import {useSelector} from "react-redux";

const SearchFixedAssetMovements = () => {
    const advancedTypes = useSelector((state) => state.SETTINGS.settings.advancedTypes);
    const documentTypesOptions = advancedTypes.length > 0 ?
        advancedTypes.filter((el) => el.section === "Fixed Asset Movements").map((o) => {
            return {
                value: o._id,
                label: o.name,
            }
        })
        : [];

    const searchFilters = {
        filters: [
            {
                name: "identifier",
                label: "Όνομα/Κωδικός περιέχοντος Παγίου",
                type: "input",
                mdWidth: 4,
            },
            {
                name: "documentType",
                label: "Τύπος Παραστατικού",
                type: "multiselect",
                options: documentTypesOptions,
                mdWidth: 4,
            },
            {
                name: "totalSum_from",
                label: "Ποσό από",
                type: "input",
                mdWidth: 2,
            },
            {
                name: "totalSum_to",
                label: "Ποσό έως",
                type: "input",
                mdWidth: 2,
            },
            {
                name: "preNumber_from",
                label: "Σειρά από",
                type: "input",
                mdWidth: 2,
            },
            {
                name: "preNumber_to",
                label: "Σειρά έως",
                type: "input",
                mdWidth: 2,
            },
            {
                name: "number_from",
                label: "Αριθμός από",
                type: "number",
                mdWidth: 2,
            },
            {
                name: "number_to",
                label: "Αριθμός έως",
                type: "number",
                mdWidth: 2,
            },
        ],
        actions: ["quick-edit", "delete"],
    }

    const scColumns = [
        {
            name: "Ημερομηνία",
            field: "date",
            editable: false,
            inputType: {
                type: 'date',
            }
        },
        {
            name: "Τύπος Παραστατικού",
            field: "documentTypeName",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: "Συνολικό αποσβεσμένο ποσό",
            field: "sum",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
    ]

    const [tableColumns, setTableColumns] = useState(scColumns.slice());

    // It will hide or show the table columns for search table.
    const handleColumnShowHide = (field) => {
        let tempTc = tableColumns.slice();
        let object = getObjectFromArrayOfObjects(tempTc, field, 'field')
        const index = tempTc.findIndex((item) => field === item.field);
        if (object.length > 0) {
            tempTc[index].hiddenColumn = !object['0'].hiddenColumn;
            setTableColumns(tempTc);
        }
    }

    return (
        <React.Fragment>
            <SearchTable
                tableName="Fixed Asset Movements Search"
                key={"Fixed Asset Movements Search"}
                hideYearFilter={false}
                allowPagination={true}
                allowToggleColumns={true}
                showDummyData={false}
                allowPrintResults={true}
                dataEndpoint={"/fixedassets/search-fixed-asset-movements"}
                exportFileName={"Κινήσεις Παγίων"}
                columns={tableColumns}
                toggleColumns={handleColumnShowHide}
                allowSelectionCheckbox={false}
                data={[]}
                filtersConfig={searchFilters}
            />
        </React.Fragment>
    )
}

export default SearchFixedAssetMovements;
